<script>
  import { onMount, onDestroy } from 'svelte';
  import { lang } from '../lib/stores';
  let corporate = '';
  let legal = '';
  let loading = true;
  let error = false;

  let selectedLang;
	const unsubscribe = lang.subscribe((value) => selectedLang = value);

  const loadFooter = async () => {
    const footerLegalURL = `https://visualize.news/remotes/footer/legal_${selectedLang}.html`;
    const footerCorporateURL = `https://visualize.news/remotes/footer/corporate_${selectedLang}.html`;
    try {
      const responseLegal = await fetch(footerLegalURL);
      legal = await responseLegal.text();
      const responseCorporate = await fetch(footerCorporateURL);
      corporate = await responseCorporate.text();
      loading = false;
    } catch(e) {
      console.warn(e);
      loading = false;
      error = true;
    }
  }

	onDestroy(unsubscribe);

  onMount(async () => {
    loadFooter();
  });

  $: selectedLang, loadFooter();
</script>

<section class="footer vn">
  <div class="footer-inner">
    <div class="sources">
      {#if selectedLang === 'it'}
        <h3>Design e Sviluppo</h3>
        <p>
          Analisi, design, testi e sviluppo, <a href="https://simonelippolis.com" target="_blank">Simone Lippolis</a>
          con l'amichevole aiuto di <a href="https://javiercruz.com/" target="_blank">Javier Cruz Mota</a>,
          <a href="https://francescastignani.com" target="_blank">Francesca Stignani</a> e <a
          href="https://carlo.im/" target="_blank">Carlo Zapponi</a> per <a href="https://visualize.news"
          target="_blank">VisualizeNews</a>.
        </p>
      {:else}
          <h3>Design and Development</h3>
          <p>
            Analysis, design, texts, and development, <a href="https://simonelippolis.com" target="_blank">Simone Lippolis</a>
            with a friendly help from <a href="https://javiercruz.com/" target="_blank">Javier Cruz Mota</a>,
            <a href="https://francescastignani.com" target="_blank">Francesca Stignani</a> e <a
            href="https://carlo.im/" target="_blank">Carlo Zapponi</a> for <a href="https://visualize.news"
            target="_blank">VisualizeNews</a>.
          </p>
      {/if}
    </div>
    {#if !loading || error}
      <div class="cols">
        <div class="col legal">
          <div class="footer-vn footer-vn-legal">{@html legal}</div>
        </div>
        <div class="col corporate">
          <div class="footer-vn footer-vn-corporate">{@html corporate}</div>
        </div>
      </div>
    {/if}
  </div>
</section>

<style>
  .footer {
    background: var(--grey-darker);
    color: var(--grey-lightest);
    display: block;
  }

  :global(.footer.vn ul) {
    margin-bottom: 2rem;
  }

  .footer-inner {
    padding: 5vh 2rem;
  }

  .footer .col.legal {
    margin-bottom: 2rem;
  }

  @media screen and (min-width: 1260px) {
    .footer-inner {
      margin: 0 auto;
      max-width: 1200px;
      padding: 5vh 0;
    }
  }

  .footer .cols,
  .footer .sources {
    display: block;
    margin: 0 20px;
    width: auto;
  }

  .footer .sources {
    margin-bottom: 2rem;
  }

  @media screen and (min-width:1024px) {
    .footer .col.legal {
      margin: 0;
    }

    .footer .sources {
      margin: 2rem 0;
    }

    .footer .cols {
      display: flex;
      margin: 0 -20px;
    }

    .footer .col.legal {
      flex: 0 0 70%;
      padding: 0 20px;
    } 

    .footer .col.corporate {
      flex: 0 0 30%;
      padding: 0 20px;
    }
  }
</style>